import React, { Suspense } from "react";

import LinkFooter from "@/features/ui/components/link-footer";
import {
  TrendsPanel,
  LiveTvPanel,
  SignUpPanel,
  CtaBanner,
  SuggestedGroupsPanel,
  TruthPlusPanel,
} from "@/features/ui/util/async-components";
import { useLoggedIn } from "@/hooks";

import { Layout } from "../components/ui";

interface HomePageProps {
  children: React.ReactNode;
}

const HomePage: React.FC<HomePageProps> = ({ children }) => {
  const { isLoggedIn } = useLoggedIn();

  return (
    <>
      <Layout.Main>
        {children}

        {!isLoggedIn && (
          <Suspense fallback={null}>
            <CtaBanner key="cta-banner" />
          </Suspense>
        )}
      </Layout.Main>

      <Layout.Aside>
        {!isLoggedIn && (
          <Suspense fallback={null}>
            <SignUpPanel />
          </Suspense>
        )}
        <Suspense fallback={null}>
          <TruthPlusPanel key="truth-plus-panel" />
        </Suspense>
        <Suspense fallback={null}>
          <LiveTvPanel key="live-tv-panel" />
        </Suspense>
        <Suspense fallback={null}>
          <TrendsPanel limit={3} />
        </Suspense>
        {isLoggedIn && (
          <Suspense fallback={null}>
            <SuggestedGroupsPanel key="suggested-groups-panel" />
          </Suspense>
        )}
        <LinkFooter key="link-footer" />
      </Layout.Aside>
    </>
  );
};

export default HomePage;
